import { Component, OnInit, Inject, PLATFORM_ID, HostListener, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { Meta, Title } from '@angular/platform-browser';
declare var $: any;
import 'lazysizes';
// Services
import { PageService } from '../providers/page/page.service';
import { CasestudyService } from '../providers/casestudy/casestudy.service';

@Component({
  selector: 'app-casestudy',
  templateUrl: './casestudy.component.html',
  styleUrls: ['./casestudy.component.scss']
})
export class CasestudyComponent implements OnInit {
  @ViewChild('myVideo') videoElement!: ElementRef;
  limit: number = 10; // <==== Edit this number to limit API results
  baseUrl: any;
  Url: any;
  imagepath: any;
  spline: any;
  url_key: any;
  casestudyData: any;
  backendURL: any;
  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    private pageservice: PageService,
    private metaTagService: Meta,
    private titleService: Title,
    private casestudy: CasestudyService,
    public route: ActivatedRoute
  ) {
    this.imagepath = environment.backendUrl + '/public/';
    this.baseUrl = environment.baseUrl + '/assets';
    this.get_PageMeta();
    this.backendURL = environment.backendUrl + '/public';
    this.url_key = this.route.snapshot.paramMap.get('url_key');
    if (this.url_key) {
      this.get_case_study();
    }
  }
  ngOnInit() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  get_PageMeta() {
    let obj = { pageName: 'home' };
    this.pageservice.getpageWithName(obj).subscribe((response) => {
      if (response.code == 200) {
        this.titleService.setTitle(response?.body.result.meta_title);
        this.metaTagService.updateTag({
          name: 'description',
          content: response?.body.result.meta_description,
        });
        this.metaTagService.updateTag({
          name: 'keywords',
          content: response?.body.result.meta_keywords,
        });
        this.metaTagService.updateTag({
          rel: 'canonical',
          href: 'https://www.pixtar.ae/home',
        });
      } else if (response.code == 400) {
      } else {
      }
    });
  }

  ngAfterViewInit() {
    const elem = this.videoElement.nativeElement;
    elem.muted = true; // Ensure the video is muted for autoplay compatibility
    elem.loop = true;

    // Attempt to autoplay the video when the component initializes
    elem.play().catch((err) => {
      console.log('Autoplay failed, user interaction may be required:', err);
    });

    if (!this.sliderRef || !this.handleRef) {
      console.error('Slider references not found!');
    }
  }

  playInFullscreenWithAudio() {
    const elem = this.videoElement.nativeElement;

    // Unmute the video
    elem.muted = false;
    elem.loop = true;

    // Remove controls to avoid interference in fullscreen mode
    elem.removeAttribute('controls');

    // Attempt to play the video and request fullscreen
    elem
      .play()
      .then(() => {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) {
          // Safari
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          // IE11
          elem.msRequestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          // Firefox
          elem.mozRequestFullScreen();
        }
      })
      .catch((err) => {
        console.log('Error entering fullscreen with audio: ', err);
      });
  }

  @HostListener('document:fullscreenchange', ['$event'])
  onFullscreenChange() {
    const elem = this.videoElement.nativeElement;

    if (
      document.fullscreenElement === elem ||
      (document as any).webkitFullscreenElement === elem ||
      (document as any).msFullscreenElement === elem ||
      (document as any).mozFullScreenElement === elem
    ) {
      // Video is in fullscreen, attempt to play
      elem.play().catch((err) => {
        console.log('Could not play in fullscreen mode:', err);
      });
    } else {
      // Video exited fullscreen, restore controls and mute the video
      elem.setAttribute('controls', '');
      elem.muted = true;
    }
  }

  beforeImage = 'http://i.imgur.com/BIHN8KQ.jpg';
  afterImage = 'http://i.imgur.com/nS6dvpq.jpg';
  beforeAlt = 'Before';
  afterAlt = 'After';

  dragging = false;
  sliderPosition = 50;

  @ViewChild('sliderRef', { static: false }) sliderRef!: ElementRef;
  @ViewChild('handleRef', { static: false }) handleRef!: ElementRef;

  onMouseDown(event: MouseEvent | TouchEvent) {
    event.preventDefault();
    this.dragging = true;
  }

  @HostListener('document:mouseup')
  @HostListener('document:touchend')
  onMouseUp() {
    this.dragging = false;
  }

  adjustSlider() {
    this.sliderPosition = 50; // Reset position after images load
  }

  @HostListener('document:mousemove', ['$event'])
  @HostListener('document:touchmove', ['$event'])
  onMouseMove(event: MouseEvent | TouchEvent) {
    if (!this.dragging) return;

    const container = this.sliderRef.nativeElement;
    const pageX =
      (event as TouchEvent).touches?.[0]?.pageX || (event as MouseEvent).pageX;
    const containerRect = container.getBoundingClientRect();

    let position = ((pageX - containerRect.left) / containerRect.width) * 100;
    this.sliderPosition = Math.max(0, Math.min(100, position));
  }

  // get case study data
  get_case_study(): void {
    const obj = { url_key: this.url_key };
    this.casestudy.getCaseStudy(obj).subscribe(
      (response: any) => {
        if (response.body.code === 200 && response.body.result) {
          this.casestudyData = response.body.result;
          if (this.casestudyData && this.casestudyData.services.length > 0) {
            this.casestudyData.services = this.casestudyData.services.sort((a, b) => a.sequence_number - b.sequence_number);
          }
        }
      },
      (error) => {
        console.error('Failed to fetch projects:', error);
      }
    );
  }

}
